module.exports = __webpack_public_path__ + "static/media/60-sb.4b61a710.jpeg";